
import IconAction from '@/components/IconAction/IconAction.vue'
import RemoteEntity from '@/models/RemoteEntity'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    IconAction,
  },
})
export default class RemoteDetails extends Vue {
  @Prop()
  public item!: RemoteEntity

  @Prop()
  public hidden!: any

  public getImg(item: any) {
    let img = item.companies_details[item.connection].logo
    // eslint-disable-next-line global-require, import/no-dynamic-require
    return require(`@/assets/remote-companies/${img.split('/').pop()}`)
  }

  public isHidden(key: string) {
    if (!this.hidden) return false
    return this.hidden.includes(key)
  }

  public get limitArr() {
    if (this.item.media_plans.length > 3) {
      return this.item.media_plans.slice(0, 3)
    }
    return this.item.media_plans
  }
}
